export default __webpack_public_path__ + "static/media/street.d69b1360.png";